import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './service_worker';
import { ApiService } from './store/ApiService';
import { i18n } from './i18n';

const app = createApp(App);

app.config.globalProperties.date_format = (input, format = 'DD-MM-YYYY') => {
    return moment(input, 'YYYY-MM-DD').format(format);
};

app.config.globalProperties.round = (number, precision = 2) => {
    let factor = Math.pow(10, precision);
    return (Math.round(number * factor) / factor).toFixed(2);
};

app.config.globalProperties.cdn = (path) => {
    let cdn = 'https://' + (ApiService.getTld() === 'app' ? 'cdn' : 'cdn-test') + '.booqi.app/' + path;
    return cdn;
};

app.use(router);
app.use(store);
app.use(i18n);

app.mount('#app');
